/* ------------------------------------------------------------------------------------------------------------------------------
				                    Footer Link Nudge Starts
------------------------------------------------------------------------------------------------------------------------------ */    
$(document).ready(function() {		    
		
	
	$(".linkNudge").hover(function()
		{
			$(this).animate({ left: '10px' }, 100);
		}, function() {
			$(this).animate({ left: 0 }, 100);
	});
				
}); 

/* ------------------------------------------------------------------------------------------------------------------------------
					     Footer Link Nudge Starts
------------------------------------------------------------------------------------------------------------------------------ */





/* ------------------------------------------------------------------------------------------------------------------------------
				           Clear Search Store Field On Focus Starts
------------------------------------------------------------------------------------------------------------------------------ */    



$(document).ready(function() {		    
		
	
	$(".searchStoreFormInput").focus(function(){
		if (this.value == "Search Store..." ) $(this).attr("value", "");
		
	});
	
	$(".searchStoreFormInput").blur(function(){
		if (this.value == "" ) $(this).attr("value", "Search Store...");
		
	});
				
}); 



/* ------------------------------------------------------------------------------------------------------------------------------
					   Clear Search Store Field On Focus Ends
------------------------------------------------------------------------------------------------------------------------------ */









/* ------------------------------------------------------------------------------------------------------------------------------
					   Product Thumbnail Nav Starts
------------------------------------------------------------------------------------------------------------------------------ */

$(document).ready(function() {		    
		
	
	$("#thumbImage2").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});
	
	$("#thumbImage3").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	
	
	$("#thumbImage4").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	

	$("#thumbImage5").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	

	$("#thumbImage6").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	

	$("#thumbImage7").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	

	$("#thumbImage8").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	

	$("#thumbImage9").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	

	$("#thumbImage10").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	

	$("#thumbImage11").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	

	$("#thumbImage12").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});	

	$("#thumbImage13").click(function(){
		var thisSrc = $(this).attr("src");
		temp = thisSrc.split('_');
		thisSrc = temp[0] + '_large.jpg';		
		$("#galleryImage1").attr("src", thisSrc);
		return false;
	});		

	
});

/* ------------------------------------------------------------------------------------------------------------------------------
					   Product Thumbnail Nav Ends
------------------------------------------------------------------------------------------------------------------------------ */
